<template>
  <div id="invitation">
    <van-row>
      <van-col span="24" class="invitation_withdrawal">
        <van-col span="24" class="invitation_withdrawal_bg">
          <van-col span="24" class="invitation_pinless_pay">
            <van-col span="24" class="invitation_pinless_pay_div">
              <van-col span="7" class="invitation_pinless_pay_div_name">{{ $t('column.alipay_account')}}</van-col>
              <van-col span="17" class="invitation_pinless_pay_div_val">
                <van-field v-model="user.alipay_account" :placeholder="$t('placeholder.enter_alipay_account')" />
              </van-col>
            </van-col>

            <van-col span="24" class="invitation_pinless_pay_div">
              <van-col span="7" class="invitation_pinless_pay_div_name">{{ $t('column.alipay_name')}}</van-col>
              <van-col span="17" class="invitation_pinless_pay_div_val">
                <van-field v-model="user.alipay_name" :placeholder="$t('placeholder.enter_alipay_name')" />
              </van-col>
            </van-col>
          </van-col>

        </van-col>

        <van-col span="18" offset="3" class="invitation_withdrawal_pay_btn" @click="binding_btn()">{{ $t('btn.confirm_binding')}}</van-col>
        <van-col span="24" class="iphonex_bottom"></van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        user: {},
        number: ''
      }
    },
    created: function() {
      this.convert()
      document.title = this.$t('title.invitation')
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=pinless", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.user = res.data.data
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      },
      binding_btn () {

        if (!this.user.alipay_name) {
          Toast(this.$t('Tips.enter_account_name'))
          return false
        }
        if (!this.user.alipay_account) {
          Toast(this.$t('Tips.bind_alipay_account'))
          return false
        }
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=pinless_add", {
          params : {
            token: token,
            pay: this.user.alipay_account,
            pay_name: this.user.alipay_name
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error)
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation_pinless.vue